import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getWithExpiry } from '../../../Domain/Helpers/LocalStorageHelper';
import { getCasinos } from '../../../Infrastructure/Services/CasinoService';

function CasinosPage({ setLoggedIn }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const token = getWithExpiry('token');
    if (!token) { setLoggedIn(false); return; }
    setLoading(true);
    try {
      const result = await getCasinos(token);
      if (result) setData(result);
    } catch { toast.error('Failed to load casinos'); }
    finally { setLoading(false); }
  }, [setLoggedIn]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div>
          <h4 className="page-title">Casinos</h4>
          <p className="page-subtitle">Casino list from the platform</p>
        </div>
        <button className="btn btn-fadeblack btn-sm" onClick={load} disabled={loading}>
          {loading ? <span className="spinner-border spinner-border-sm me-1" /> : '↻'} Refresh
        </button>
      </div>

      <div className="card-section">
        {loading && data.length === 0 ? (
          <div className="text-center p-4">
            <div className="spinner-border text-secondary" role="status" />
          </div>
        ) : data.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">♦</div>
            <p>No casinos found</p>
          </div>
        ) : (
          <table className="table table-hover table-sm align-middle">
            <thead>
              <tr>
                <th>ID</th>
                <th>Company Name</th>
                <th>Parent ID</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.map(row => (
                <tr key={row.id}>
                  <td><span className="badge bg-secondary">{row.id}</span></td>
                  <td><strong>{row.company_name}</strong></td>
                  <td>
                    {row.parent_id
                      ? <span className="badge bg-light text-dark border">{row.parent_id}</span>
                      : <span className="text-muted" style={{ fontSize: 12 }}>Root</span>
                    }
                  </td>
                  <td>
                    <span className={`badge ${row.is_active ? 'bg-success' : 'bg-danger'}`}>
                      {row.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CasinosPage;
